import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as EmptySvg2 } from 'assets/svg/empty-state-2.svg';
import { Button } from 'reactstrap';
import classnames from 'classnames';
import Check from 'services/Check';

export const EmptyScreen = (props) => {
  const {
    aux,
    title,
    addButtonPermission,
    titleClassName,
    primaryControl: PrimaryControl,
    showAddButton,
    showImportButton,
    primaryClick,
    addButtonText,
    secondaryClick,
    subTitle,
    footer,
  } = props;

  return (
    <div className="settings__empty-content">
      <div className="settings__empty-img">{aux ? <EmptySvg2 /> : ''}</div>
      <p className={`tw-text-[1.6rem] tw-text-natural-700 ${titleClassName}`}>{title}</p>
      <p className={`tw-text-[1.4rem] tw-text-natural-500`}>{subTitle || ''}</p>
      {footer && (
        <Check permission={addButtonPermission}>
          <div className="settings__empty-footer">
            {PrimaryControl ? (
              <PrimaryControl {...props} />
            ) : showAddButton ? (
              <div className="add-action">
                <Button className={classnames('btn__secondary')} onClick={primaryClick}>
                  {addButtonText}
                </Button>
              </div>
            ) : null}
            {showImportButton && (
              <div className="import-action">
                <Button className={classnames('btn__utility')} onClick={secondaryClick}>
                  Upload list
                </Button>
              </div>
            )}
          </div>
        </Check>
      )}
    </div>
  );
};

EmptyScreen.defaultProps = {
  title: 'No Branches',
  addButtonText: 'add branch',
  footer: false,
  showImportButton: true,
  showAddButton: true,
};

EmptyScreen.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  addButtonText: PropTypes.string,
  footer: PropTypes.bool,
  aux: PropTypes.bool,
  titleClassName: PropTypes.string,
  addButtonPermission: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  showAddButton: PropTypes.bool,
  showImportButton: PropTypes.bool,
  primaryClick: PropTypes.func,
  secondaryClick: PropTypes.func,
  primaryControl: PropTypes.func,
};
